module.exports = __webpack_public_path__ + "static/media/dynamic-feature.ea0b1341.svg";